import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Gate a route by any combination of:
 *  - roles:      legacy explicit role list (e.g. ['super_admin'])
 *  - permission: a permission key (e.g. 'inward.view')
 *  - module:     a feature-flag module key (e.g. 'inward')
 * Super Admin bypasses permission/module checks via can()/featureEnabled().
 */
const ProtectedRoute = ({ children, roles, permission, module }) => {
  const { isAuthenticated, user, isLoading, can, featureEnabled } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zip-bg">
        <div className="w-8 h-8 border-2 border-zip-border border-t-zip-red rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to="/unauthorized" replace />;
  if (module && !featureEnabled(module)) return <Navigate to="/unauthorized" replace />;
  if (permission && !can(permission)) return <Navigate to="/unauthorized" replace />;

  return children;
};

export default ProtectedRoute;
